
export default function filterStyles (theme) {
  return {
    filters: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column'
    },
    top: {
      display: 'flex',
      padding: '15px 10px 0 20px'
    },
    filler: {
      flexGrow: 1
    },
    bottom: {
      display: 'flex',
      padding: '0 10px 15px 20px'
    },
    select: {
      marginLeft: 15,
      width: 165,
      '&:first-child': {
        marginLeft: 0
      },
    },
    patternFilter: {
      display: 'flex',
      marginLeft: 15,
      paddingTop: 15,
    },
    patternInput: {
      borderRadius: 5,
      border: 'solid 1px #becfd7',
    },
    standardsSearch: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginLeft: 8,
    },
    standardsSearchLink: {
      color: '#009dd8',
      fontSize: '9.5pt'
    },
    chips: {
      display: 'none',
      '&.hasChips': {
        display: 'flex',
        borderTop: 'solid 1px #becfd7',
        display: 'flex',
        padding: '10px 15px'
      },
      '& .filter-chip': {
        backgroundColor: '#de3434',
        color: '#fff',
        '& .MuiChip-label': {
          padding: '0 20px'
        },
        '& .MuiChip-deleteIcon': {
        }
      }
    },
  }
}
